import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  padding: 0.75rem 1rem;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.875rem;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--colors-brand-primary);

  > h3 {
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--colors-foreground-100);
  }
`;

export const LeaderboardLink = styled(Link)`
  ${({ theme }) => css`
    font-size: 0.6875rem;
    color: ${theme.colors.brand.primary.default};
    font-weight: 600;
  `}
`;

export const EmptyState = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1rem 0.75rem 0.75rem;
    gap: 0.375rem;

    > svg {
      color: ${theme.colors.brand.primary.default};
      opacity: 0.85;
      margin-bottom: 0.125rem;
    }

    > strong {
      font-size: 0.8125rem;
      font-weight: 600;
      color: ${theme.colors.foreground[100]};
    }

    > span {
      font-size: 0.6875rem;
      color: ${theme.colors.foreground[60]};
      line-height: 1.4;
      max-width: 14rem;
    }
  `}
`;

export const TopCard = styled.div`
  background: linear-gradient(135deg, #fff9e6, #fff3cc);
  border-radius: 0.6rem;
  padding: 0.625rem 0.75rem;
  margin-bottom: 0.25rem;
  border: 1px solid #ffe69c;
  position: relative;
  overflow: hidden;
`;

export const TopCardGlow = styled.div`
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 50%;
  background: rgba(255, 215, 0, 0.15);
`;

export const TopCardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`;

export const TopAvatarWrapper = styled.div`
  position: relative;
`;

export const TopAvatar = styled.div`
  width: 2.375rem;
  height: 2.375rem;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 2px solid #ffe69c;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RankBadge = styled.div`
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #ffd700;
  border: 2px solid #fff9e6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  font-weight: 800;
  color: white;
`;

export const TopInfo = styled.div`
  flex: 1;

  > div:first-child {
    font-size: 0.8125rem;
    font-weight: 700;
  }

  > div:last-child {
    font-size: 0.625rem;
    color: #b8860b;
    font-weight: 500;
  }
`;

export const TopPoints = styled.div`
  text-align: right;

  > div:first-child {
    font-size: 0.9375rem;
    font-weight: 800;
    color: #b8860b;
  }
`;

export const TrendUp = styled.div`
  ${({ theme }) => css`
    font-size: 0.5625rem;
    color: ${theme.colors.success[100]};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.125rem;
    justify-content: flex-end;
  `}
`;

export const RunnerCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.625rem 0.75rem;
    border-radius: 0.625rem;
    margin-bottom: 0.25rem;
    background: ${theme.colors.background[80]};
    border: 1px solid ${theme.colors.background[60]};
  `}
`;

export const RunnerRank = styled.div<{ $color: string }>`
  ${({ $color }) => css`
    width: 1.375rem;
    height: 1.375rem;
    border-radius: 50%;
    background: ${$color};
    opacity: 0.85;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.625rem;
    font-weight: 800;
    color: white;
  `}
`;

export const RunnerAvatar = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  overflow: hidden;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RunnerInfo = styled.div`
  flex: 1;

  > div:first-child {
    font-size: 0.75rem;
    font-weight: 600;
  }

  > div:last-child {
    font-size: 0.625rem;
    color: var(--colors-foreground-40);
  }
`;

export const RunnerPoints = styled.div`
  text-align: right;

  > div:first-child {
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--colors-foreground-80);
  }
`;
